import React from "react";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { copyYear } from "app/config";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  phantom: {
    display: "block",
    padding: "20px 0px",
    width: "100%",
    height: "22px",
  },
  footer: {
    backgroundColor: "#2e5e11 !important",
    bottom: 0,
    fontSize: ".9rem",
    height: "auto",
    lineHeight: "39px",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "100%",
    borderRadius: "0 !important",
  },
}));

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation("shared");
  return (
    <>
      <div className={classes.phantom} />
      <Paper className={classes.footer}>
        <Grid container direction="row" justifyContent="space-between">
          <span style={{ color: "white", paddingLeft: 20 }}>
            {t("footer.site")}
            <a href={t("footer.link")} style={{ color: "#beeb20" }}>
              {" "}
              {t("footer.link")}
            </a>
            <br />
            {t("footer.support")}{" "}
            <a href="#" style={{ color: "#beeb20" }}>
              support@asonika.com
            </a>
          </span>
          <span style={{ color: "white", paddingRight: 20 }}>
            <br />
            &copy;2005 - {copyYear} {t("footer.asonika")}
          </span>
        </Grid>
      </Paper>
    </>
  );
};

export default Footer;
